module.exports = __webpack_public_path__ + "img/index-view.7a824815.png";